import filter from "lodash/filter";

const SUCCESS_TOKEN = "_SUCCESS";
const FAILURE_BAD_REQUEST_TOKEN = "_FAILURE_BADREQUEST";
const FAILURE_UNAUTHORIZED_TOKEN = "_FAILURE_UNAUTHORIZED";
const FAILURE_TOKEN = "_FAILURE";
const STARTED_TOKEN = "_STARTED";

const getActionNames = actionName => ({
  success: actionName + SUCCESS_TOKEN,
  failure: actionName + FAILURE_TOKEN,
  started: actionName + STARTED_TOKEN,
  failureBadRequest: actionName + FAILURE_BAD_REQUEST_TOKEN,
  failureUnauthorized: actionName + FAILURE_UNAUTHORIZED_TOKEN,
});

const defaultReducers = {
  success: (state, action) => state,
  failure: (state, action) => state,
  started: (state, action) => state,
  failureBadRequest: (state, action) => ({
    ...state,
    validationErrors: action.payload?.validationErrors,
  }),
};

const httpMultipleActionsReducer = (
  actionNames = [],
  initialState = {},
  reducers = {},
  config = {}
) => (state = initialState, action) => {
  const matchingActions = filter(actionNames, actionName => action.type.startsWith(actionName));
  if (matchingActions.length > 0) {
    return httpReducer(matchingActions[0], initialState, reducers, config)(state, action);
  }
  return state || initialState;
};

const httpReducer = (actionName, initialState, reducers, config = {}) => (state, action) => {
  reducers = { ...defaultReducers, ...reducers };
  state = state || initialState;
  const loadingKeyName = config.loadingKeyName || "isLoading";
  const actionNames = getActionNames(actionName);

  switch (action.type) {
    case actionNames.success:
      return reducers.success({ ...state, [loadingKeyName]: false }, action);
    case actionNames.failure:
      return reducers.failure({ ...state, [loadingKeyName]: false }, action);
    case actionNames.started:
      return reducers.started({ ...state, [loadingKeyName]: true }, action);
    case actionNames.failureBadRequest: {
      const badRequestReducer = reducers.failureBadRequest || reducers.failure;
      return badRequestReducer({ ...state, [loadingKeyName]: false }, action);
    }
    case actionNames.failureUnauthorized: {
      const unauthorizedReducer = reducers.failureUnauthorized || reducers.failure;
      return unauthorizedReducer({ ...state, [loadingKeyName]: false }, action);
    }
    default:
      return state;
  }
};

const reduceReducers = (...reducers) => (state, action) =>
  reducers.reduce((state, reducer) => reducer(state, action), state);

export { httpReducer, httpMultipleActionsReducer, reduceReducers, getActionNames };
